module.exports = __webpack_public_path__ + "static/media/IAP_SplitGreen@3x.8236075e.png";